// Статусы партнёра и начислений — подписи и цвета для чипов (используются в списках и Show).

type ChipColor = "default" | "success" | "warning" | "error" | "info";

const PARTNER: Record<string, { label: string; color: ChipColor }> = {
  pending: { label: "Заявка", color: "warning" },
  approved: { label: "Работает", color: "success" },
  rejected: { label: "Отказ", color: "error" },
  blocked: { label: "Заблокирован", color: "error" },
};

const ACCRUAL: Record<string, { label: string; color: ChipColor }> = {
  pending: { label: "Ожидание", color: "default" },
  hold: { label: "Холд", color: "warning" },
  available: { label: "Доступно", color: "success" },
  cancelled: { label: "Отменено", color: "error" },
};

const PAYOUT: Record<string, { label: string; color: ChipColor }> = {
  pending: { label: "Ожидает", color: "warning" },
  completed: { label: "Исполнена", color: "success" },
  rejected: { label: "Отклонена", color: "error" },
  cancelled: { label: "Отменена", color: "default" },
};

export const partnerStatus = (s: string) => PARTNER[s] ?? { label: s, color: "default" as ChipColor };
export const accrualStatus = (s: string) => ACCRUAL[s] ?? { label: s, color: "default" as ChipColor };
export const payoutStatus = (s: string) => PAYOUT[s] ?? { label: s, color: "default" as ChipColor };

export const MODEL_LABEL: Record<string, string> = {
  referral: "Реферал (% с оборота)",
  agent: "Агент (своя наценка)",
};

export const PAYOUT_METHOD_LABEL: Record<string, string> = {
  card: "Зарубежная карта",
  swift: "SWIFT-перевод",
  crypto: "Крипто-кошелёк (TRC20)",
  internal: "На свой счёт",
};
